import { ConfirmationModal, Strong, Text } from '@customerio/pluma-components/react';
import plur from 'plur';

import { type Asset } from '@/services/db/asset/entity';

type DeleteConfirmationModalProps = {
  assetsToDelete: Asset[];
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteConfirmationModal({ assetsToDelete, onClose, onConfirm }: DeleteConfirmationModalProps) {
  const isOpen = assetsToDelete.length > 0;

  const title = `Delete ${
    assetsToDelete.length === 1 ? (assetsToDelete[0]?.is_dir ? 'folder' : 'image') : 'multiple assets'
  }`;

  const message = (
    <>
      <Text display="block">
        Are you sure you want to delete{' '}
        <Strong>{assetsToDelete.length === 1 ? assetsToDelete[0]?.name : `${assetsToDelete.length} items`}</Strong>?
      </Text>
      {assetsToDelete.some((a) => !a.is_dir) ? (
        <Text mt="100" display="block">
          Deleting only removes the {plur('image', assetsToDelete.length)} from this asset library. Existing messages
          will not be affected.
        </Text>
      ) : null}
    </>
  );

  const data = {
    title,
    message,
    confirmLabel: 'Delete',
    cancelLabel: 'Cancel',
    isDanger: true,
  };

  return <ConfirmationModal modalState={{ isOpen }} onConfirm={onConfirm} onClose={onClose} data={data} />;
}
